import { render, staticRenderFns } from "./AddResourceSupplier.vue?vue&type=template&id=53c01b3d"
import script from "./AddResourceSupplier.vue?vue&type=script&lang=js"
export * from "./AddResourceSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports